import { gql } from "@apollo/client";

export default gql`
  query getDeliveredEngagementSurveys(
    $organizationId: Int!
    $after: String
    $orderBy: String!
  ) {
    engagementSurveyDeliveries(
      organizationId: $organizationId
      first: 10
      after: $after
      orderBy: $orderBy
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          deliveryDatetime
          lastSubmissionDatetime
          target {
            id
            name
            email
            firstName
            avatar
          }
          complianceProgram {
            id
            title
          }
        }
      }
    }
  }
`;
